import { useTranslation } from "react-i18next";
import ToggleSwitch from "common/components/ToggleSwitch/ToggleSwitch";
import { BalanceSheetDisplayOptions } from "types/SavedBalanceSheet";

export const DEFAULT_DISPLAY_OPTIONS: BalanceSheetDisplayOptions = {
  showDistributionGraph: true,
  showEvolutionGraph: true,
  showBadCriteriaGraph: true,
  showCommentsGraph: true,
  showSectionGraph: true,
  showSubEventsInGraph: true,
  showSubEnclosureUpdateInGraph: true,
  showSubEnrichmentInGraph: true,
  showEvents: true,
  showEnclosureUpdate: true,
  showEnrichment: true,
};

type Props = {
  value: BalanceSheetDisplayOptions;
  onChange: (value: BalanceSheetDisplayOptions) => void;
};

function BalanceSheetDisplayToggles({ value, onChange }: Props) {
  const { t } = useTranslation();

  const toggle = (key: keyof BalanceSheetDisplayOptions) => (val: boolean) => {
    onChange({ ...value, [key]: val });
  };

  return (
    <div className="flex flex-row flex-wrap gap-10">
      <ToggleSwitch
        value={value.showDistributionGraph}
        onChange={toggle("showDistributionGraph")}
        rightLabel={t("forms.answersByDomain")}
      />
      <ToggleSwitch
        value={value.showEvolutionGraph}
        onChange={toggle("showEvolutionGraph")}
        rightLabel={t("forms.answersOverTime")}
      />
      <ToggleSwitch
        value={value.showBadCriteriaGraph}
        onChange={toggle("showBadCriteriaGraph")}
        rightLabel={t("forms.negativeAnswersDistribution")}
      />
      <ToggleSwitch
        value={value.showCommentsGraph}
        onChange={toggle("showCommentsGraph")}
        rightLabel={t("forms.observationComments")}
      />
      <ToggleSwitch
        value={value.showSectionGraph}
        onChange={toggle("showSectionGraph")}
        rightLabel={t("forms.answersBySectionOverTime")}
      />
      <ToggleSwitch
        value={value.showSubEventsInGraph}
        onChange={toggle("showSubEventsInGraph")}
        rightLabel={t("forms.alertsInEvolutionGraph")}
      />
      <ToggleSwitch
        value={value.showSubEnclosureUpdateInGraph}
        onChange={toggle("showSubEnclosureUpdateInGraph")}
        rightLabel={t("forms.changesInEvolutionGraph")}
      />
      <ToggleSwitch
        value={value.showSubEnrichmentInGraph}
        onChange={toggle("showSubEnrichmentInGraph")}
        rightLabel={t("forms.enhancementsInEvolutionGraph")}
      />
      <ToggleSwitch
        value={value.showEvents}
        onChange={toggle("showEvents")}
        rightLabel={t("forms.alertsInSheet")}
      />
      <ToggleSwitch
        value={value.showEnclosureUpdate}
        onChange={toggle("showEnclosureUpdate")}
        rightLabel={t("forms.changesInSheet")}
      />
      <ToggleSwitch
        value={value.showEnrichment}
        onChange={toggle("showEnrichment")}
        rightLabel={t("forms.enhancementsInSheet")}
      />
    </div>
  );
}

export default BalanceSheetDisplayToggles;
